import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './responsive.css';
import App from './App';
import { HashRouter } from "react-router-dom";
import WrapContexts from './contexts/wrapContexts';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HashRouter>
      <WrapContexts>
        <App />
      </WrapContexts>
    </HashRouter>

  </React.StrictMode>
);

